import React from "react";
import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

const EASE = [0.22, 1, 0.36, 1];

// Client brand logos — single moving band, ordered as specified by the team.
// If a logo fails to load, the brand name text fallback is shown.
const BRANDS = [
  { name: "Tata Intellion", src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/h3nuqxdf_intellionworkspaces_cover.jpeg" },
  {
    name: "Under Armour",
    src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/lvx3g5ok_Under_Armour-Logo.wine.webp",
    scale: 1.35,
  },
  { name: "Laphroaig", src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/8tzzxvfy_laphroaig-vector-logo.png" },
  { name: "Asics", src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/ifvp9n6s_ASICS_Corporation_logo.png" },
  { name: "Renault", src: "/logos/renault-logo.png" },
  { name: "Nando's", src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/r782hu54_Nandos-Logo.webp", scale: 1.3 },
  { name: "Teacher's", src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/0cr1gosx_495a73158024219.Y3JvcCwxMDgwLDg0NCwwLDExNw.png", scale: 0.9 },
  { name: "Godrej Capital", src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/xmgg63o8_Godrej_Capital_Logo.jpg", scale: 1.1 },
  { name: "Audi", src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/0cowrarw_Audi-Logo-1995-2009.webp" },
  { name: "ISMA", src: "/logos/isma-logo.png" },
  { name: "Zepto", src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/fvgjnv0d_Zepto_Logo.svg.png" },
  { name: "BMW Motorrad", src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/lp6royf3_Abhinav%20Documents-2.png" },
  { name: "Amazon", src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/jzhcxrfr_Amazon_logo.svg-2.png" },
  { name: "Govt. of Odisha", src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/vnluba8v_Seal_of_Odisha.png" },
  { name: "Govt. of Assam", src: "https://customer-assets-lxgj4vgw.emergentagent.net/job_work-portfolio-239/artifacts/giqpchuj_Seal_of_Assam.png" },
];

function BrandCircle({ brand, i }) {
  const [failed, setFailed] = React.useState(!brand.src);
  const scale = brand.scale || 1;

  return (
    <div
      className="group shrink-0 w-24 h-24 md:w-[8.4rem] md:h-[8.4rem] mx-3 md:mx-5 rounded-full bg-white flex items-center justify-center p-2 md:p-3 shadow-[0_1px_0_rgba(0,0,0,0.06)]"
      data-testid={`brand-${i}`}
      aria-label={brand.name}
    >
      {failed ? (
        <span className="text-center text-[color:var(--collab-ink)] font-mono text-[10px] md:text-xs uppercase tracking-[0.14em] leading-tight px-1">
          {brand.name}
        </span>
      ) : (
        <img
          src={brand.src}
          alt={brand.name}
          onError={() => setFailed(true)}
          className="w-[92%] h-[92%] object-contain"
          style={scale !== 1 ? { transform: `scale(${scale})` } : undefined}
          loading="lazy"
          draggable="false"
        />
      )}
    </div>
  );
}

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative bg-[color:var(--collab-forest)] text-[color:var(--collab-cream)] pt-4 md:pt-6 pb-16 md:pb-24 overflow-hidden"
    >
      <div className="shell">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1, ease: EASE, delay: 0.1 }}
          className="font-display font-light text-lg md:text-3xl lg:text-4xl leading-[1.15] tracking-[-0.02em] max-w-4xl mx-auto balance text-center"
        >
          Trusted by brands that inspire
        </motion.h2>
      </div>

      {/* Moving brand band — one continuous row, loops seamlessly */}
      <div className="mt-10 md:mt-14" data-testid="brand-band">
        <Marquee speed={70} gradient={false} pauseOnHover>
          {BRANDS.concat(BRANDS).map((brand, i) => (
            <BrandCircle key={`${brand.name}-${i}`} brand={brand} i={i % BRANDS.length} />
          ))}
        </Marquee>
      </div>
    </section>
  );
}
